import React from "react";
import PropTypes from "prop-types";
import { Checkbox, Button } from "antd";

const DropdownFilter = ({
  //   title = "Filtrar país",
  selectedKeys,
  setSelectedKeys,
  filters = [],
  confirm
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", padding: 8 }}>
      <Checkbox.Group
        options={filters.map(({ text, value }) => ({
          value,
          label: text || value
        }))}
        onChange={setSelectedKeys}
        value={selectedKeys}
        style={{ flexDirection: "column", display: "flex", marginBottom: 8 }}
      />
      <Button data-test="filter" size="small" type="primary" onClick={confirm}>
        Filtrar
      </Button>
      {(selectedKeys || []).length > 0 && (
        <Button
          size="small"
          onClick={() => {
            setSelectedKeys([]);
            confirm();
          }}
          style={{ marginTop: 4 }}
        >
          Borrar filtros
        </Button>
      )}
    </div>
  );
};

DropdownFilter.propTypes = {
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string
    })
  ),
  onSelect: PropTypes.func.isRequired,
  visible: PropTypes.bool
};

export default DropdownFilter;
